require('./style.less');


var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    tagName: 'span',

    // TODO: maybe even cache the template ?
    serializeData: function() {
        return this.model.get('textPreviewTemplateContext');
    },

    ui: {
        hitLink:    '.fr-preview-hit'
    },

    events: {
        'click @ui.hitLink': 'hitLinkClick'
    },

    // Left an href to keep get keyboard events
    hitLinkClick: function(e) {

        e.preventDefault();
        this.options.channel.trigger( 'findAndRedact:userClickedHit', this.model );

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/hitRow/textPreview/view.js
 ** module id = 625
 ** module chunks = 0
 **/